module.exports = __webpack_public_path__ + "static/media/dev-support-icon.db137537.svg";